<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>中间商</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          :inline="true"
          class="filter"
          label-width="80px"
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item
            label="名称"
            prop="name"
            v-if="isMobile() && !filterShow"
          >
            <el-input
              v-model="filter.name"
              size="small"
              autocomplete="off"
              @keyup.enter.native="submitSearchForm"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item
              label="名称"
              prop="name"
              v-if="filterShow || !isMobile()"
            >
              <el-input
                v-model="filter.name"
                size="small"
                autocomplete="off"
                @keyup.enter.native="submitSearchForm"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="SAP Code"
              prop="sap_code"
              v-if="
                (filterShow || !isMobile()) && auth.isPlatformUser() && !repeat
              "
            >
              <el-input
                size="small"
                v-model="filter.sap_code"
                autocomplete="off"
                @keyup.enter.native="reqeustCustomers()"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="销售(服务)"
              prop="user_id"
              v-if="auth.belongsToDepartment(1)"
            >
              <sale-select
                :val="filter.user_id"
                @change="filter.user_id = $event"
                ref="filterUser"
              ></sale-select>
            </el-form-item>
            <el-form-item
              label="销售(工业)"
              prop="industry_sale_id"
              v-if="auth.belongsToDepartment(2)"
            >
              <sale-select
                :val="filter.industry_sale_id"
                @change="filter.industry_sale_id = $event"
                ref="filterUser"
              ></sale-select>
            </el-form-item>
            <el-form-item
              label="销售(科学)"
              prop="science_sale_id"
              v-if="auth.belongsToDepartment(3)"
            >
              <sale-select
                :val="filter.science_sale_id"
                @change="filter.science_sale_id = $event"
                ref="filterUser"
              ></sale-select>
            </el-form-item>
            <el-form-item label="电话销售" prop="telesale_id">
              <telesale-select
                :val="filter.telesale_id"
                @change="filter.telesale_id = $event"
                ref="filterTelesale"
              ></telesale-select>
            </el-form-item>
            <el-form-item label="拥有设备" prop="item_category_id">
              <item-category-select
                :val="filter.item_category_id"
                :category="2"
                @change="filter.item_category_id = $event"
                ref="filterItemCategoryID"
              ></item-category-select>
            </el-form-item>
            <el-form-item label="授权服务商" prop="is_fix_dealer">
              <el-select size="small" v-model="filter.is_fix_dealer">
                <el-option :key="0" label="不限" :value="0"></el-option>
                <el-option :key="1" label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类别" prop="category_id">
              <el-select
                v-model="filter.category_id"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option key="-1" label="所有" value></el-option>
                <el-option
                  v-for="(value, name) in DealerCategories"
                  :key="name"
                  :label="value"
                  :value="name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="级别(服务)" v-if="auth.belongsToDepartment(1)">
              <el-select
                v-model="filter.rank"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option key="-1" label="所有" value></el-option>
                <el-option
                  v-for="(value, name) in DealerRanks"
                  :key="name"
                  :label="value"
                  :value="name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="级别(工业)" v-if="auth.belongsToDepartment(2)">
              <el-select
                v-model="filter.rank_industry"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option key="-1" label="所有" value></el-option>
                <el-option
                  v-for="(value, name) in DealerRanks"
                  :key="name"
                  :label="value"
                  :value="name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="级别(科学)" v-if="auth.belongsToDepartment(3)">
              <el-select
                v-model="filter.rank_science"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option key="-1" label="所有" value></el-option>
                <el-option
                  v-for="(value, name) in DealerRanks"
                  :key="name"
                  :label="value"
                  :value="name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="区域"
              prop="area_id"
              v-if="auth.isPlatformUser()"
            >
              <area-select
                :showNoAreaSelect="true"
                :val="filter.area_id"
                @change="filter.area_id = $event"
                ref="filterAreaID"
              ></area-select>
            </el-form-item>
            <el-form-item label="省市区" prop="area">
              <el-cascader
                style="width: 100%"
                size="small"
                class="long"
                :options="regionDataPlus"
                v-model="filter.area"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="系统状态" prop="status">
              <el-select
                v-model="filter.status"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option key="-1" label="所有" :value="-1"></el-option>
                <el-option key="0" label="已禁用" :value="0"></el-option>
                <el-option key="1" label="已启用" :value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="客户状态" v-if="!deleted">
              <el-select
                v-model="filter.customer_status"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                :clearable="true"
              >
                <el-option
                  v-for="(value, index) in CustomerStatusMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="直销客户" v-if="auth.isPlatformUser()">
              <el-select
                v-model="filter.special_mark"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option :key="-1" label="不限" :value="-1"></el-option>
                <el-option :key="1" label="直销客户" :value="1"></el-option>
                <el-option :key="2" label="间销客户" :value="2"></el-option>
                <el-option :key="0" label="其他" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="认证状态" v-if="auth.isPlatformUser()">
              <el-select
                v-model="filter.certification"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option :key="0" label="不限" :value="0"></el-option>
                <el-option
                  :key="2"
                  label="已认证（有 SAP Code）"
                  :value="2"
                ></el-option>
                <el-option
                  :key="1"
                  label="未认证（无 SAP Code）"
                  :value="1"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="最终客户" prop="customer_count">
              <el-radio
                class="font-12"
                v-model="filter.customer_count"
                :label="1"
                >无</el-radio
              >
              <el-radio
                class="font-12"
                v-model="filter.customer_count"
                :label="2"
                >有</el-radio
              >
            </el-form-item> -->
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                submitSearchForm()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header flex-row-between">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="startDealerFormer()"
          v-permission="Auth.dealerNew"
          >新增中间商</el-button
        >
        <file-button
          v-permission="Auth.dealerIE"
          obj="dealer"
          :filter="filter"
          class="mobile-hide"
          @importCallback="importCallback"
        ></file-button>
      </div>
      <el-table v-if="!isMobile()" :data="agents" stripe style="width: 100%">
        <el-table-column prop="name" label="中间商名称" min-width="200">
          <template slot-scope="scope">
            <dealer-link
              :id="scope.row.id"
              :name="scope.row.name"
            ></dealer-link>
            <div v-if="scope.row.name_en" style="line-height: 1.4em">
              {{ scope.row.name_en }}
            </div>
            <!-- <router-link
              :to="{
                path:
                  '/dashboard/admin/customers?dealer_id=' +
                  scope.row.id +
                  '&dealer_name=' +
                  scope.row.name
              }"
              >{{ scope.row.name }}</router-link
            >-->
            <div>
              {{ codeToText[scope.row.province_id]
              }}{{ codeToText[scope.row.city_id]
              }}{{ codeToText[scope.row.county_id] }}
              {{ scope.row.address_detail }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customer_count" label="设备数量" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.customer_count || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类别" align="center">
          <template slot-scope="scope">
            {{ DealerCategories[scope.row.category_id] }}
          </template>
        </el-table-column>
        <el-table-column label="级别" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.rank > 0">
              {{ DealerRanks[scope.row.rank] }}(服务)
            </div>
            <div v-if="scope.row.rank_industry > 0">
              {{ DealerRanks[scope.row.rank_industry] }}(工业)
            </div>
            <div v-if="scope.row.rank_science > 0">
              {{ DealerRanks[scope.row.rank_science] }}(科学)
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="center" width="124">
          <template slot-scope="scope">
            <div>{{ scope.row.contact_name }}</div>
            <div>{{ scope.row.contact_mobile }}</div>
          </template>
        </el-table-column>
        <el-table-column label="销售" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.user.name">
              {{ scope.row.user.name }}(服务)
            </div>
            <div v-if="scope.row.industry_sale.name">
              {{ scope.row.industry_sale.name }}(工业)
            </div>
            <div v-if="scope.row.science_sale.name">
              {{ scope.row.science_sale.name }}(科学)
            </div>
          </template>
        </el-table-column>
        <el-table-column label="电话销售" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.telesale.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="系统状态" align="center">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
              >{{ scope.row.status == 1 ? '已启用' : '已禁用' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <dealer-link
              :id="scope.row.id"
              :name="scope.row.name"
              v-permission="Auth.dealerShow"
            >
              <el-button slot="content" size="mini" type="primary" plain
                >查看</el-button
              >
            </dealer-link>
            <!-- <el-button
              class="ml-10"
              size="mini"
              type="primary"
              plain
              @click="startDealerFormer(scope.row, scope.$index)"
              >编辑</el-button
            >-->

            <!-- <router-link to="/dashboard/admin/agent">
              <el-button type="primary" plain size="mini">查看</el-button>
            </router-link>-->
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="agent in agents" :key="agent.id">
          <div>
            <dealer-link :id="agent.id" :name="agent.name"></dealer-link>
            <div v-if="agent.name_en" style="line-height: 1.4em">
              {{ agent.name_en }}
            </div>
          </div>
          <div class="text-info-12" style="margin-top: 5px">
            联系人：{{ agent.contact_name }}
            <template v-if="agent.contact_mobile.length > 0">
              (
              <a :href="'tel:' + agent.contact_mobile">{{
                agent.contact_mobile
              }}</a
              >)
            </template>
            <div class="text-info-12">
              <!-- 级别：{{ DealerRanks[agent.rank] }} -->
              <span>类别：{{ DealerCategories[agent.category_id] }}</span>
              <span class="ml-10">设备数量：{{ agent.customer_count }}</span>
            </div>
            <div class="text-info-12">
              地址：{{ codeToText[agent.province_id]
              }}{{ codeToText[agent.city_id] }}{{ codeToText[agent.county_id] }}
              {{ agent.address_detail }}
            </div>
            <div class="mt-10">
              <dealer-link
                :id="agent.id"
                :name="agent.name"
                v-permission="Auth.dealerShow"
              >
                <el-button slot="content" size="mini" type="primary" plain
                  >查看</el-button
                >
              </dealer-link>
            </div>
            <!-- <div class="flex-row-between" style="margin-top: 5px;">
              <span
                :class="agent.status == 1 ? 'text-success' : 'text-danger'"
                >{{ agent.status == 1 ? '已启用' : '已禁用' }}</span
              >
              <span>
                <el-popconfirm
                  :title="'确认' + statusText(agent.status) + '吗？'"
                  @confirm="handleSwtichStatus(index, agent.id)"
                >
                  <el-button
                    slot="reference"
                    :type="agent.status == 1 ? 'danger' : 'success'"
                    size="mini"
                    plain
                    >{{ statusText(agent.status) }}</el-button
                  >
                </el-popconfirm>
                <el-button
                  class="ml-10"
                  size="mini"
                  type="primary"
                  plain
                  @click="startDealerFormer(agent, index)"
                  >编辑</el-button
                >
              </span>
            </div>-->
          </div>
        </li>
      </ul>
      <div class="mt-20">
        <el-pagination
          @current-change="handlePageChange"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <dealer-former
      :model="dealerForm"
      :show.sync="dealerFormerVisible"
      @updated="updatedDealer"
      @created="createdDealer"
    ></dealer-former>
  </div>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { CodeToText } from '@/util/area_tool'
import { getStore } from '@/config/storage'
import { isMobile, scrollToTop } from '@/util/index'

import {
  dealerList,
  createDealer,
  updateDealer,
  swtichDealerStatus,
} from '@/service/getData'
import { clone } from '@/util'
import { regionDataPlus } from '@/util/area_tool'
import DealerFormer from '@/components/dealer'
import {
  DealerRanks,
  DealerCategories,
  CustomerStatusMap,
} from '../../config/global.js'
import SaleSelect from '@/components/select/sale_select'
import AreaSelect from '@/components/select/area_select'
import TelesaleSelect from '@/components/select/telesale_select'
import ItemCategorySelect from '@/components/select/item_category_select'
import auth from '@/util/auth'

export default {
  props: {
    deleted: {
      type: Boolean,
      default: false,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DealerFormer,
    SaleSelect,
    TelesaleSelect,
    AreaSelect,
    ItemCategorySelect,
  },
  data() {
    return {
      auth,
      DealerRanks,
      DealerCategories,
      CustomerStatusMap,
      regionDataPlus,
      isMobile,
      scrollToTop,
      codeToText: CodeToText,
      regionData: regionData,
      filter: {
        name: '',
        sap_code: '',
        area_id: 0,
        special_mark: -1,
        item_category_id: 0,
        certification: 0,
        rank: '',
        rank_industry: '',
        rank_science: '',
        page: 1,
        size: 20,
        customer_count: 0,
        category_id: '',
        user_id: 0,
        telesale_id: 0,
        industry_sale_id: 0,
        science_sale_id: 0,
        area: [],
        status: -1,
        customer_status: -1,
        is_fix_dealer: 0,
      },
      total: 0,
      filterShow: false,
      addAgencyVisible: false,
      dealerForm: {},
      dealerFormerVisible: false,
      agents: [],
      editIndex: 0,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.requestDealers()
  },
  methods: {
    async requestDealers() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      const data = this.clone(this.filter)
      data.page -= 1

      let area = data.area
      if (area.length > 0) {
        data.province = area[0]
      }
      if (area.length > 1) {
        data.city = area[1]
      }
      if (area.length > 2) {
        data.county = area[2]
      }

      let res = await dealerList(data)
      if (res.code == 0) {
        this.agents = res.data.list
        this.total = res.data.total
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestDealers()
    },
    async handleSwtichStatus(index, id) {
      let res = await swtichDealerStatus(id)
      if (res.code == 0) {
        this.agents[index].status = res.data.status
        this.$message({
          message: `${res.data.status == 1 ? '启用' : '禁用'}成功`,
          type: 'success',
          center: true,
        })
      }
    },
    startDealerFormer(dealer, index) {
      if (dealer) {
        this.editIndex = index
        this.dealerForm = clone(dealer)
        this.dealerForm.area = [
          this.dealerForm.province_id,
          this.dealerForm.city_id,
          this.dealerForm.county_id,
        ]
      } else {
        this.dealerForm = {
          name: null,
          rank: 0,
          is_fix_dealer: 0,
          rank_industry: 0,
          rank_science: 0,
          category_id: 1,
          contact_name: null,
          contact_mobile: null,
          agent_name: null,
          agent_mobile: null,
          area: [],
          address_detail: null,
          sap_code: null,
          ec_deadline: null,
          customer_status: 1,
          area_id: 0,
          industry: '',
          source: '',
          scale: '',
          important: 1,
          special_mark: 0,
        }
      }
      this.dealerFormerVisible = true
    },
    updatedDealer(dealer) {
      this.agents.splice(this.editIndex, 1, dealer)
    },
    createdDealer(dealer) {
      this.agents.unshift(dealer)
    },
    statusText(status) {
      return status == 1 ? '禁用' : '启用'
    },
    submitSearchForm() {
      this.requestDealers()
    },

    reset() {
      this.filter.name = ''
      this.filter.rank = ''
      this.filter.rank_industry = ''
      this.filter.rank_science = ''
      this.filter.category_id = ''
      this.filter.area = []
      this.filter.page = 1
      this.filter.status = -1
      this.filter.customer_count = 0
      this.filter.is_fix_dealer = 0
      this.filter.user_id = 0
      this.filter.telesale_id = 0
      this.filter.industry_sale_id = 0
      this.filter.science_sale_id = 0
      this.requestDealers()
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
  },
}
</script>

<style scoped>
/deep/.el-radio .el-radio__label {
  font-size: 12px !important;
}
</style>